import { render } from "./SchedaUtente.vue?vue&type=template&id=fbec2638&scoped=true"
import script from "./SchedaUtente.vue?vue&type=script&lang=js"
export * from "./SchedaUtente.vue?vue&type=script&lang=js"

import "./SchedaUtente.vue?vue&type=style&index=0&id=fbec2638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbec2638"]])

export default __exports__